import { AuthenticatedHttp } from '@/http/axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';

export function useUpdateApiKey(apiKeyId, enabled = true) {
    const notify = useNotify();
    const queryClient = useQueryClient();

    const getApiKeyById = async (id) => {
        try {
            const { data } = await AuthenticatedHttp.get(`/public_api/api_key/${id}/`);
            return data;
        } catch (error) {
            notify.error('Algo deu errado ao buscar API key!');
            return null;
        }
    };

    const { data: apiKeyById, isLoading: isLoadingApiKey } = useQuery({
        queryKey: ['api-key-by-id', apiKeyId],
        queryFn: () => getApiKeyById(apiKeyId),
        enabled: enabled && !!apiKeyId,
    });

    const updateApiKeyMutation = useMutation({
        mutationFn: async (formData) => {
            const formatScopesSelected = formData.scopes.join(' ');

            const { data } = await AuthenticatedHttp.put(`/public_api/api_key/${apiKeyId}/`, {
                name: formData.name,
                scope: formatScopesSelected,
            });

            return data;
        },
        onSuccess: () => {
            notify.success('Chave de API atualizada com sucesso!');
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
            queryClient.invalidateQueries({ queryKey: ['api-key-by-id', apiKeyId] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar API key:', error);
            notify.error(
                error?.response?.data?.detail || 'Erro ao atualizar chave de API. Tente novamente.'
            );
        }
    });

    return {
        apiKeyById,
        isLoadingApiKey,
        updateApiKey: updateApiKeyMutation.mutate,
        isUpdating: updateApiKeyMutation.isLoading,
        error: updateApiKeyMutation.error,
    };
}
